<div *ngIf="!activado">
    <h1>
        <mat-icon>warning_amber</mat-icon>
        ACTIVACIÓN DE LA CUENTA
    </h1>
    <p>SU CUENTA HA SIDO CREADA Y ESTÁ PENDIENTE DE ACTIVACIÓN. RECUERDE QUE NO PODRÁ REALIZAR PEDIDOS HASTA QUE LOS
        TÉCNICOS DE CNC DENTAL HABILITEN SU CUENTA.</p>
    <p>UNA VEZ HABILITADA, LE NOTIFICAREMOS VÍA ELECTRÓNICA SOBRE LA POSIBILIDAD DE COMENZAR A REALIZAR PEDIDOS</p>
</div>
<div *ngIf="activado">
    <h1>BIENVENIDO A CNC DENTAL</h1>
    <p>SU CUENTA ESTÁ ACTIVA. PUEDE REALIZAR SUS PEDIDOS Y CONSULTAR SU ACTIVIDAD DESDE EL MENÚ.</p>
    <p><a routerLink="/inicio">IR A INICIO</a></p>
</div>
